import { render } from "./cabecera.vue?vue&type=template&id=0f7d9a62&scoped=true&ts=true"
import script from "./cabecera.vue?vue&type=script&lang=ts"
export * from "./cabecera.vue?vue&type=script&lang=ts"

import "./cabecera.vue?vue&type=style&index=0&id=0f7d9a62&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Dell\\latam\\latamlogistichn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7d9a62"]])

export default __exports__